/* src/app/main/pages/pages.component.css */
/*# sourceMappingURL=pages.component.css.map */
